import { useState, useEffect } from "react";
import { Menu, X, MessageCircle, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { whatsappLink, COMPANY_NAME } from "@/lib/api";

const LINKS = [
  { label: "Serviços MEI", href: "#servicos" },
  { label: "Regularização CPF", href: "#servicos" },
  { label: "Serviços Detran", href: "#servicos" },
  { label: "Como Funciona", href: "#como-funciona" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar({ onStart }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-sm" : "bg-white/70 backdrop-blur-sm"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-[72px]">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5 shrink-0">
          <span className="grid place-items-center h-10 w-10 rounded-xl bg-[#0F294A] text-white">
            <ShieldCheck className="h-5 w-5 text-emerald-400" />
          </span>
          <span className="font-heading font-extrabold text-[#0F294A] leading-none text-base sm:text-lg">
            Central <span className="text-emerald-600">MEI</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-slate-600 hover:text-[#0F294A] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a href="/acompanhar" data-testid="nav-track-link" className="text-sm font-medium text-slate-600 hover:text-[#0F294A]">
            Acompanhar
          </a>
          <a href="/admin/login" data-testid="nav-admin-link" className="text-sm font-medium text-slate-400 hover:text-slate-600">
            Área Admin
          </a>
          <a href={whatsappLink(`Olá! Preciso de ajuda com os serviços da ${COMPANY_NAME}.`)} target="_blank" rel="noreferrer">
            <Button data-testid="nav-whatsapp-cta" className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-full px-5 gap-2 font-semibold">
              <MessageCircle className="h-4 w-4" /> Falar no WhatsApp
            </Button>
          </a>
        </div>

        <button data-testid="nav-mobile-toggle" className="lg:hidden p-2 text-[#0F294A]" onClick={() => setOpen(!open)}>
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-white border-t border-slate-200 px-4 py-4 space-y-1">
          {LINKS.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="block py-2.5 text-slate-700 font-medium border-b border-slate-100">
              {l.label}
            </a>
          ))}
          <div className="pt-3 flex flex-col gap-2">
            <Button data-testid="nav-mobile-start" onClick={() => { setOpen(false); onStart(); }} className="bg-[#0F294A] text-white rounded-full">
              Iniciar Atendimento
            </Button>
            <a href="/acompanhar" className="text-center text-sm text-slate-500 py-1">Acompanhar pedido</a>
            <a href="/admin/login" className="text-center text-sm text-slate-400 py-1">Área Admin</a>
          </div>
        </div>
      )}
    </header>
  );
}
